import { call, put, takeLatest } from 'redux-saga/effects';

import SuppliesService from 'shared/services/SuppliesService';
import {
  failAction,
  getPharmacySupplies,
  setPharmacySupplies
} from './supplies.redux';
import { TAction } from 'shared/types';
import { IResponsePharmacySupplies } from 'shared/interfaces/supply.interface';

function* getPharmacySuppliesSaga({
  payload
}: TAction<{ pharmacyId: string }>) {
  try {
    const result: IResponsePharmacySupplies[] = yield call(
      SuppliesService.getPharmacySupplies,
      payload
    );
    yield put(setPharmacySupplies(result));
  } catch (error) {
    console.log('error', error);
    yield put(failAction());
  }
}

function* Supplies() {
  yield takeLatest(getPharmacySupplies.type, getPharmacySuppliesSaga);
}

export default Supplies;
